import { Route, Routes } from "react-router-dom";

import AuthLayout from "./layouts/AuthLayout";
import authRouterList from "./lists/auth.routes";
import Page404 from "@/modules/common/support-pages/404";
import MainLayout from "./layouts/MainLayout";
import mainRouterList from "./lists/main.routes";
import { ProtectedRoute } from "./components/ProtectedRoute";

const RoutesProvider = () => {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        {authRouterList.map((route, index) => (
          <Route key={index} path={route.path} element={<route.element />} />
        ))}
      </Route>
      <Route element={<MainLayout />}>
        {mainRouterList.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              route.minimumRole ? (
                <ProtectedRoute minimumRole={route.minimumRole}>
                  <route.element />
                </ProtectedRoute>
              ) : (
                <route.element />
              )
            }
          />
        ))}
      </Route>
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default RoutesProvider;
